import { LeftOutlined } from '@ant-design/icons';

export type BackButtonProps = {
  onClick: () => void;
};

export default function BackButton(props: BackButtonProps) {
  const { onClick } = props;

  return (
    // `aria-label` kept identical to the old `<Image alt="back-button">` — the
    // functional suite locates this button by that exact accessible name
    // (`get_by_role("img", name="back-button")`) in ~20 places.
    <LeftOutlined
      aria-label="back-button"
      className="pointer-events-auto flex cursor-pointer items-center text-2xl text-foreground"
      onClick={() => onClick()}
    />
  );
}
